import { filter, find, get, head, includes, values } from 'lodash';
import PageKey from '../../../lib/page-data/key';

export const isLoadingVideo = (state, videoId) => {
  const events = get(state, 'media.videos.loadingVideos', []);
  return includes(events, videoId);
};

export const hasLoadedVideo = (state, videoId) => {
  const events = get(state, 'media.videos.loadedVideos', []);
  return includes(events, videoId);
};

export const getVideo = (state, videoId) => {
  const videos = get(state, 'media.videos.videos', []);
  return find(videos, { id: videoId });
};

export const getRelatedVideos = (state, videoId) =>
  values(get(state, `media.videos.relatedVideos.${videoId}`, {}));

export const getWatchedVideos = (state) => get(state, 'media.videos.watchedVideos', []);

export const getNextVideo = (state, videoId) => {
  const relatedVideos = getRelatedVideos(state, videoId);
  const watchedVideos = getWatchedVideos(state);
  const relatedVideosNotWatched = filter(
    relatedVideos,
    (video) => !includes(watchedVideos, video.video_id),
  );

  return head(relatedVideosNotWatched);
};

export const getVideoList = (state, teamId, page, search) => {
  const key = search ? `${teamId}-${page}-${search}` : `${teamId}-${page}`;
  return get(state, `media.videos.videoLists[${key}]`, []);
};

export const getVideoPageLoadingError = (state, videoId) =>
  get(state, `media.videos.loadingErrors[${videoId}]`);

export const getVideoListPageLoadingError = (state, teamId, page, search) => {
  const key = search ? `${teamId}-${page}-${search}` : `${teamId}-${page}`;
  return get(state, `media.videos.loadingErrors[${key}]`);
};

export const getVideoListPagination = (state, teamId = 0, search) => {
  const key = search ? `${teamId}-${search}` : teamId;
  return get(state, `media.videos.pagination[${key}]`);
};

export const hasLoadedVideoList = (state, clubId, teamId, page, search) => {
  const key = new PageKey(clubId, 'video_list', { teamId, page, search });
  return includes(get(state, `activityStream.loaded`), key.toString());
};
